<template>
  <div :style="applicationColors(application.status)" class="application relative">
    <action-list-menu
      :application="application"
      :approval-command="approvalCommand"
      :base-url="baseUrl"
      :items="application.statusActions"
      :user="user"
    >
      <template v-slot:prevItems>
        <b-dropdown-item v-if="canCheck(application)"
          :to="{name: 'view-vts', params: {mode: 'view', id: application.id}}">
          <div>
            <img :src="baseUrl + '/img/icons/statuses/show.svg'" alt="" class="menu-item-img"
              height="22px" width="20px"/>
            Посмотреть
          </div>
        </b-dropdown-item>

        <b-dropdown-item v-if="canView(application) && application.status !== 'awaiting_signing'"
          :to="{name: 'view-vts', params: {mode: 'view', id: application.id}}">
          <div>
            <img :src="baseUrl + '/img/icons/statuses/show.svg'" alt="" class="menu-item-img"
              height="22px" width="20px"/>
            Посмотреть
          </div>
        </b-dropdown-item>
        <b-dropdown-item v-if="canPrint(application)" :href="printUrl" target="_blank">
          <div>
            <img :src="baseUrl + '/img/icons/statuses/pdf_file.svg'" alt="" class="menu-item-img"
              height="22px" width="20px"/>
            Распечатать
          </div>
        </b-dropdown-item>
        <b-dropdown-item v-if="canFixActualDate">
          <router-link
            :to="{name: 'view-vts', hash: '#actual-date-block',  params: {mode: 'view', id: application.id}}">
            <img :src="baseUrl + '/img/icons/statuses/confirm.svg'" alt="" class="menu-item-img"
              height="22px" width="20px"/>
            Указать фактическую дату
          </router-link>
        </b-dropdown-item>

        <b-dropdown-item v-if="canModify" :to="{name: 'view-vts', params: {mode: 'edit', id: application.id}}">
          <div>
            <img :src="baseUrl + '/img/icons/statuses/edit.svg'" alt="" class="menu-item-img"
              height="22px" width="20px"/>
            Редактировать
          </div>
        </b-dropdown-item>

        <b-dropdown-item
          v-if="Number(application.user_id) === Number(user.id) && application.status === 'awaiting_signing'">
          <a :href="url(`site/index?view=${application.id}#scan-copy-block`)">
            <img :src="baseUrl + '/img/icons/statuses/scan.svg'" class="menu-item-img" height="22px"
              width="20px"/>
            Приложить скан-копию
          </a>
        </b-dropdown-item>
      </template>

      <template v-slot:lastItems>
        <b-dropdown-item v-if="canDuplicate(application)"
          :to="{name: 'view-vts', params: {mode: 'duplicate', id: application.id}}">
          <div>
            <img :src="baseUrl + '/img/icons/statuses/copy.svg'" alt="" class="menu-item-img"
              height="22px" width="20px"/>
            Дублировать
          </div>
        </b-dropdown-item>

        <b-dropdown-item v-if="canDelete(application)">
          <a href="#" @click="deleteApplication(application)">
            <img :src="baseUrl + '/img/icons/statuses/delete.svg'" alt="" class="menu-item-img"
              height="22px" width="20px"/>
            Удалить
          </a>
        </b-dropdown-item>
      </template>
    </action-list-menu>
    <div class="row">
      <div class="col-sm-4 col-xs-8">
        <span v-if="application.status === 'draft'"><b>Черновик</b></span>
        <span v-else>
          <span v-if="user && user.role === 'sb' && application && application.terminal && application.terminal.logo">
            <img :src="baseUrl + '/' + application.terminal.logo" alt="" class="terminal-icon">
          </span>
          <b>№{{ application.number }}</b>
        </span>
        <span>
          <b> от {{ parseDate(application.created_at) }}</b>
        </span>
      </div>
      <div class="col-sm-4 col-xs-12 application-status-container relative">
        <div>
          <img v-if="Number(application.has_user_sign) === 1"
            :src="baseUrl + '/img/trusted.png'"
            alt="Подписано ЭЦП"
            data-original-title="Заявка подписана усиленной электронной подписью"
            data-toggle="tooltip"
            style="margin-left: -2px; height: 18px"
          >
          <b>{{ application.status !== 'draft' && statuses && statuses[application.status] ?
            statuses[application.status].name : '' }}
          </b>
        </div>
      </div>
      <div class="col-sm-2 col-xs-12 application-status-container relative">
      </div>
    </div>
    <div class="row">
      <div class="col-sm-4 col-xs-12 overflow-block">
        <span v-if="application.organization"
          :title="application.organization.need_attorney === '1' ? 'Руководитель по доверенности' : (application.organization && application.organization.name && application.organization.subject_id === 'individual' ? ('ИП' + application.organization.name) : application.organization.name) +
                (application.organization && application.organization.director_name ? ', ' + application.organization.director_name : '')"
          class="application-description-visitors">
          <template v-if="application.creator_role === 'trusted_user'">
           <img v-if="application.organization.need_attorney === '1'"
             :src="baseUrl + '/img/trusted_attorney.png'"
             alt="Доверенный"
             style="margin-left: -2px; height: 18px"
           />
           <img v-else
             :src="baseUrl + '/img/trusted.png'"
             alt="Доверенный"
             style="margin-left: -2px; height: 18px"
           />
          </template>
          <template v-else>
               <img v-if="application.organization.need_attorney === '1'"
                 :src="baseUrl + '/img/non_trusted_attorney.png'"
                 alt=""
                 style="margin-left: -2px; height: 18px"
               />
          </template>
          <span
            :style="application.creator_role === 'trusted_user' ? 'margin-left: -3px' : ''"
            :title="(application.organization && application.organization.name && application.organization.subject_id === 'individual' ? ('ИП' + application.organization.name) : application.organization.name) +
              (application.organization && application.organization.director_name ? ', ' + application.organization.director_name : '')"
          >
          {{ application.organization && application.organization.name !== '' && application.organization.subject_id === 'individual' ? 'ИП' : ''
            }}
          {{ application.organization && application.organization.name !== '' ? application.organization.name : '&nbsp;'
            }}{{ application.organization && application.organization.director_name ? ', ' + application.organization.director_name : ''
            }}
          </span>
        </span>
      </div>
      <div class="col-sm-4 col-xs-12 overflow-block">
        {{ parseDate(application.planed_date, false) }}
        <template v-if="application.actual_date">(факт {{ parseDate(application.actual_date, false) }})</template>
      </div>
      <div class="col-sm-4 col-xs-12 overflow-block">
        {{ sailTypes[application.sail_type].name }}
      </div>
    </div>
    <div class="row">
      <div :class="{'text-danger': isNewVessel}" class="col-sm-4 col-xs-12">
        <img :class="shipIconClass" :src="shipIcon" alt="" height="20" width="20"/>
        {{ application.vessel.name }}
      </div>
      <div class="col-sm-4 col-xs-12 overflow-block">
        <b-icon v-if="application.isShipDuplicatedDirection" icon="exclamation-circle-fill" variant="danger"></b-icon>
        {{ directions[application.direction].name }}
      </div>
      <div class="col-sm-4 col-xs-12 overflow-block">
        {{ vesselTypeName }}
      </div>
    </div>
    <div class="row">
      <div class="col-sm-4 col-xs-12">
      </div>
      <div class="col-sm-4 col-xs-12 overflow-block">
        {{ tonnageCostString }}
      </div>
    </div>
  </div>
</template>

<script>
import ActionListMenu from '@/components/application/ActionListMenu.vue'
import moment from 'moment/moment'
import axios from 'axios'
import ClickOutside from 'vue-click-outside'
import { ApplicationStatuses } from '@/common/enums/ApplicationStatuses'
import { UserRoles } from '@/common/enums/UserRoles'
import { BaseApiClient } from '@/common/helpers/BaseApiClient'

export default {
  name: 'ApplicationItem',

  components: { ActionListMenu },

  directives: {
    ClickOutside
  },

  props: {
    application: {
      type: Object
    },

    applicationIndex: {},

    pagination: {},

    statuses: {
      type: [Object, Array],
      default () {
        return {
          draft: {
            name: 'Черновик'
          },
          awaiting: {
            name: 'Ожидается'
          },
          confirmed: {
            name: 'Состоялся'
          },
          executed: {
            name: 'Исполнена'
          },
          discard: {
            name: 'Отозвана'
          }
        }
      }
    },

    portSailTypeCost: {}
  },

  data () {
    return {
      baseUrl: process.env.VUE_APP_API_BASE_URL,

      directions: {
        1: { name: 'Заход в акваторию' },
        2: { name: 'Выход из акватории' }
      },

      sailTypes: {
        1: { name: 'Каботажное' },
        2: { name: 'Загранплавание' }
      }
    }
  },

  computed: {
    canEdit () {
      return this.user.role === UserRoles.SUPERVISOR
    },

    canFixActualDate () {
      return this.user.role === UserRoles.DISPATCHER && this.application.status === ApplicationStatuses.AWAITING
    },

    canModify () {
      return UserRoles.MODIFY_ROLES.includes(this.user.role)
    },

    applicationPortSailType() {
      let prices = this.portSailTypeCost
        ?.filter(x => x.port_id === Number(this.application.port) && x.sail_type_id === Number(this.application.sail_type))
      const fallBackPrices = prices?.filter(x => x.begin_at === undefined) // цены из таблицы PortSailType
      const comparisonDate = this.application.actual_date ?? this.application.planed_date
      prices = prices?.filter(x => x.begin_at !== undefined && moment(x.begin_at) <= moment(comparisonDate) && (x.expired_at === null || moment(x.expired_at) >= moment(comparisonDate))) // цены из таблицы PaymentBaseTariff
      if (prices.length === 0) {
        prices = fallBackPrices;
      }

      return prices?.[0]
    },

    coefficient () {
      return this.applicationPortSailType?.cost
    },

    isNewVessel () {
      return this.application.vessel.is_new
    },

    printUrl () {
      return BaseApiClient.getUrl(`print/application-cost/?id=${this.application.id}`, true)
    },

    shipIcon () {
      return process.env.BASE_URL + '/img/icons/transports/ship.png'
    },

    shipIconClass () {
      return {
        flip: Number(this.application.direction) === 1,
        'new-ship': this.isNewVessel
      }
    },

    tonnageCost () {
      return this.numberToLocaleString(this.application.vessel.tonnage * this.coefficient)
    },

    tonnageCostString () {
      return `${this.numberToLocaleString(this.application.vessel.tonnage)} gt × ${this.numberToLocaleString(this.coefficient)} тг = ${this.tonnageCost} тг`
    },

    vesselTypeName () {
      return this.application?.vessel?.vesselType?.name
    }
  },

  methods: {
    appStatus (application, status) {
      const statusParam = this.appStatusCheck(application, status)
      const classes = {
        'profile-status-green': statusParam,
        'profile-status-red': !statusParam,
        'profile-status-close': application.visitorCloseCount !== 0 && status !== 'subdivision_yes'
      }

      switch (status) {
        case 'subdivision_yes':
          return ['agent_begin', 'awaiting_signing', 'begin', 'notactive', 'subdivision_begin'].includes(application.status) ? {} : classes
        case 'sb_begin':
          return ['agent_begin', 'agent_yes', 'awaiting_signing', 'begin', 'notactive', 'subdivision_begin', 'subdivision_no', 'subdivision_yes'].includes(application.status) ? {} : classes
        case 'fsb_begin':
          return ['agent_begin', 'agent_yes', 'awaiting_signing', 'begin', 'notactive', 'sb_begin', 'sb_yes', 'subdivision_begin', 'subdivision_no', 'subdivision_yes'].includes(application.status) ? {} : classes
        case 'fsb_no':
          return ['agent_begin', 'agent_yes', 'awaiting_signing', 'begin', 'fsb_begin', 'notactive', 'sb_begin', 'sb_no', 'sb_yes', 'subdivision_begin', 'subdivision_no', 'subdivision_yes'].includes(application.status) ? {} : classes
        case 'ktsp':
          return ['agent_begin', 'agent_yes', 'awaiting_signing', 'begin', 'fsb_begin', 'fsb_no', 'fsb_yes', 'notactive', 'sb_begin', 'sb_no', 'sb_yes', 'subdivision_begin', 'subdivision_no', 'subdivision_yes'].includes(application.status) ? {} : classes
        default:
          return classes
      }
    },

    appStatusCheck (application, status) {
      switch (status) {
        case 'subdivision_yes':
          return ['agent_begin', 'agent_yes', 'fsb_begin', 'fsb_no', 'fsb_yes', 'ktsp', 'sb_begin', 'sb_no', 'sb_yes', 'subdivision_yes'].includes(application.status)
        case 'sb_begin':
          return ['fsb_begin', 'fsb_no', 'fsb_yes', 'ktsp', 'sb_begin', 'sb_no', 'sb_yes'].includes(application.status)
        case 'fsb_begin':
          return ['fsb_begin', 'fsb_no', 'fsb_yes', 'ktsp'].includes(application.status)
        case 'fsb_no':
          return ['fsb_yes', 'ktsp'].includes(application.status)
        default:
          return ['ktsp'].includes(application.status)
      }
    },

    applicationColors (status) {
      return {
        'background-color': (this.statuses[status]?.bg_color ?? '') + ' !important',
        'border-color': (this.statuses[status]?.ln_color ?? '') + ' !important'
      }
    },

    async approvalCommand (application, statusCommandSettings) {
      const index = this.applicationIndex
      const blockId = Math.ceil((index + 1) / 5)
      const deleteFrom = (blockId - 1) * 5

      const vue = this
      let page = this.pagination.active
      const filter = this.searchStatus
      const pageCount = Number(this.pagination.count)
      let success = false

      axios.post(this.baseUrl + '/application-status/update?id=' + application.id, {
        alias: statusCommandSettings.alias
      })
        .then(async function (response) {
          if (response.status === 200) {
            success = true
            if (filter && filter !== 'all') {
              vue.applications.splice(deleteFrom)
              vue.infiniteId++
              vue.pagination.active = blockId
              vue.applications = vue.applications.concat(await vue.getPageApplications(blockId, vue.pagination.per))
              vue.insertSearchParams()
            } else {
              application.status = response.data.status
              application.statusActions = response.data.statusActions
              application.log = response.data.log
              application.pdf = response.data.pdf
              application.comment = response.data.comment
              application.has_user_sign = response.data.has_user_sign
            }
          }
        })
        .catch(function (error) {
          console.log(error.response)
          alert(error.response?.data?.message || error)

          success = false
        })
        .finally(function () {
          if (success === true) {
            if ((Number(pageCount) - 1) % 5 === 0 && (Number(page) - 1) !== 0) {
              page = Number(page) - 1
            }
          }
        })
    },

    canCheck (application) {
      if (this.user.role === 'supervisor') {
        return true
      }

      const service = ['subdivision', 'sb', 'sb_truck', 'sb_other'].includes(this.user.role)
      if (application.status === 'awaiting_signing' && !service) {
        return false
      }

      return application.status !== ApplicationStatuses.DRAFT && this.user && service
    },

    canContinueEdit (application) {
      return application.status === ApplicationStatuses.DRAFT && this.user.id === application.user_id
    },

    canDelete (application) {
      return application.status === ApplicationStatuses.DRAFT && this.user.id === application.user_id
    },

    canDuplicate (application) {
      return application.status !== ApplicationStatuses.DRAFT && ['trusted_user', 'user', 'manager'].includes(this.user.role)
    },

    canPrint (application) {
      if (this.user) {
        if (Number(this.user.id) === Number(application.user_id)) {
          return true
        }
        if (Number(this.user.extended_rule) === 1 && this.user.organization_id === application.organization_id) {
          return true
        }
      }

      return false
    },

    canView (application) {
      return application.status !== ApplicationStatuses.DRAFT &&
        this.user && !['subdivision', 'sb', 'sb_truck', 'sb_other', 'agent', 'supervisor'].includes(this.user.role)
    },

    declOfNum (number, titles, showNumber = true) {
      const cases = [2, 0, 1, 1, 1, 2]

      return (showNumber ? number + ' ' : '') + titles[(number % 100 > 4 && number % 100 < 20) ? 2 : cases[(number % 10 < 5) ? number % 10 : 5]]
    },

    getApplicationPurpose (application) {
      if (application.additional_purpose && application.applicationGroupPurpose) {
        return `${application.applicationGroupPurpose.name}: ${application.additional_purpose}`
      }

      if (application.applicationGroupPurpose) {
        return application.applicationGroupPurpose.name
      }

      return application.additional_purpose
    },

    hide () {
      const el = document.getElementById('dropdown')
      el.classList.remove('open')
    },

    parseDate (date, needTime = true) {
      if (date) {
        moment.locale('ru')
        let format = 'DD.MM.YYYY'
        format = needTime && date.length > 10 ? 'DD.MM.YYYY LT' : format

        return moment(date).format(format)
      }
    },

    url (url) {
      return this.baseUrl + '/' + url
    }
  }
}
</script>
